import React from 'react';
import { Flex, InfiniteScroll, MarginBox, Text, useInfiniteScroll } from 'UI';
import { BamCodeContainer } from './BamCommercialFamilyCodes.styled';

const FileRows = ({ fileRows }: { fileRows: string[] }) => {
  const { hasMore, loadMore, currentData } = useInfiniteScroll<string>({
    data: fileRows,
    chunkSize: 50,
  });

  return (
    <Flex direction={'column'}>
      <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
        <Flex gap={15} direction={'row'} wrap={'wrap'}>
          {currentData.map((code) => {
            return (
              <MarginBox mt={10} key={code}>
                <BamCodeContainer align={'center'} justify={'center'} minWidth={95} maxWidth={95} minHeight={35}>
                  <Text type="base">{code}</Text>
                </BamCodeContainer>
              </MarginBox>
            );
          })}
        </Flex>
      </InfiniteScroll>
    </Flex>
  );
};

export default FileRows;
